import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Box, TextField, Typography } from "@mui/material";
import { useState, useEffect } from "react";

export default function ControlledRadioButtonsGroup({
  data = [],
  setDriverType,
  setOpertaorName,
  driverType,
  operatorName,
  basicDetails,
  setBasicDetails,
  setValidateLtfrb,
  carDetails,
  setCarDetails,
}) {
  // vehicle_type is UI-only — used to filter which vehicle categories to show.
  // It is NOT saved to basicDetails or sent to the API.
  const [vehicleType, setVehicleType] = useState("");

  useEffect(() => {
    if (carDetails?.carType) {
      if (["PEEKUP_BLUE", "PEEKUP_BLUE_XL", "TAXI_EV"].includes(carDetails.carType)) {
        setVehicleType("Electric (EV)");
      } else if (["COMPACT", "PLUS", "EXECUTIVE", "TAXI"].includes(carDetails.carType)) {
        setVehicleType("Fuel/Gas");
      }
    }
  }, [carDetails?.carType]);

  const handleRadioChange = (event) => {
    setDriverType(event.target.value);
    setOpertaorName(""); // Reset the selected option when changing the radio option
    setVehicleType(""); // Reset local UI vehicle type
    setBasicDetails({
      ...basicDetails,
      tnvsCheck: "",
      operator_full_name: "",
      is_experienced: "",
    });
    setCarDetails({
      ...carDetails,
      carType: "",
    });
  };

  const handleSelectChange = (event) => {
    if (driverType !== "VIA_OPERATOR") {
      setDriverType("VIA_OPERATOR");
    }
    setOpertaorName(event.target.value);
  };

  const labelStyle = {
    color: "#6F747E",
    fontFamily: "Proxima Nova",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    marginBottom: "4px",
    lineHeight: "normal",
  };

  return (
    <Box>
      <Typography sx={labelStyle}>Operator type</Typography>
      <RadioGroup row value={driverType} onChange={handleRadioChange} sx={{ marginBottom: "16px" }}>
        <FormControlLabel value="INDIVIDUAL" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="TNVS Operator" sx={{ width: "200px" }} />
        <FormControlLabel value="VIA_OPERATOR" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="TAXI Operator" />
      </RadioGroup>

      {driverType === "INDIVIDUAL" && (
        <Box>
          <Typography sx={labelStyle}>TNVS Driver Status</Typography>
          <RadioGroup
            row
            value={basicDetails?.tnvsCheck || ""}
            onChange={(e) => {
              setBasicDetails({
                ...basicDetails,
                tnvsCheck: e.target.value,
              });
              setValidateLtfrb(e.target.value === "false" ? true : null);
            }}
            sx={{ marginBottom: "16px" }}
          >
            <FormControlLabel value="true" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Existing TNVS" sx={{ width: "200px" }} />
            <FormControlLabel value="false" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="New Applicant" />
          </RadioGroup>

          <Typography sx={labelStyle}>Vehicle Type</Typography>
          <RadioGroup
            row
            value={vehicleType}
            onChange={(e) => {
              setVehicleType(e.target.value);
              // Reset category when type changes
              setCarDetails({
                ...carDetails,
                carType: "",
              });
            }}
            sx={{ marginBottom: "16px" }}
          >
            <FormControlLabel value="Fuel/Gas" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Fuel/Gas" sx={{ width: "200px" }} />
            <FormControlLabel value="Electric (EV)" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Electric (EV)" />
          </RadioGroup>

          {vehicleType && (
            <Box>
              <Typography sx={labelStyle}>Vehicle Category</Typography>
              <RadioGroup
                row
                value={carDetails?.carType || ""}
                onChange={(e) => {
                  setCarDetails({
                    ...carDetails,
                    carType: e.target.value,
                  });
                }}
                sx={{ marginBottom: "16px" }}
              >
                {vehicleType === "Electric (EV)" ? (
                  <>
                    <FormControlLabel value="PEEKUP_BLUE" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Blue - 4 Seater" sx={{ width: "200px" }} />
                    <FormControlLabel value="PEEKUP_BLUE_XL" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Blue - 6 Seater" />
                  </>
                ) : (
                  <>
                    <FormControlLabel value="COMPACT" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Compact - 4 Seater" sx={{ width: "200px" }} />
                    <FormControlLabel value="PLUS" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Plus - 6 Seater" sx={{ width: "200px" }} />
                    <FormControlLabel value="EXECUTIVE" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Premium" sx={{ width: "200px" }} />
                  </>
                )}
              </RadioGroup>
            </Box>
          )}

          <Typography sx={labelStyle}>Operator Full Name</Typography>
          <TextField
            type="text"
            variant="outlined"
            size="small"
            color="secondary"
            value={basicDetails.operator_full_name}
            onChange={(e) => {
              setBasicDetails({
                ...basicDetails,
                operator_full_name: e.target.value,
              });
            }}
            sx={{ width: "100%", maxWidth: "380px", marginBottom: "16px" }}
          />
        </Box>
      )}

      {driverType === "VIA_OPERATOR" && (
        <Box>
          <Typography sx={labelStyle}>Taxi Driver Status</Typography>
          <RadioGroup
            row
            value={
              basicDetails?.is_experienced === null || basicDetails?.is_experienced === undefined || basicDetails?.is_experienced === ""
                ? "null"
                : String(basicDetails.is_experienced)
            }
            onChange={(e) => {
              const val = e.target.value;
              setBasicDetails({
                ...basicDetails,
                is_experienced: val === "null" ? null : val === "true",
              });
            }}
            sx={{ marginBottom: "16px" }}
          >
            <FormControlLabel value="false" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="New Driver" sx={{ width: "200px" }} />
            <FormControlLabel value="true" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Experienced Driver" />
          </RadioGroup>

          <Typography sx={labelStyle}>Vehicle Type</Typography>
          <RadioGroup
            row
            value={vehicleType}
            onChange={(e) => {
              const newVehicleType = e.target.value;
              setVehicleType(newVehicleType);
              setCarDetails({
                ...carDetails,
                carType: newVehicleType === "Electric (EV)" ? "TAXI_EV" : "TAXI",
              });

              if (newVehicleType === "Electric (EV)") {
                const carBevOperator = data.find(op => op.operator_name?.toLowerCase() === "carbev");
                if (carBevOperator) {
                  setOpertaorName(carBevOperator.id);
                }
              } else {
                setOpertaorName("");
              }
            }}
            sx={{ marginBottom: "16px" }}
          >
            <FormControlLabel value="Fuel/Gas" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Fuel/Gas" sx={{ width: "200px" }} />
            <FormControlLabel value="Electric (EV)" control={<Radio sx={{ color: '#000', '&.Mui-checked': { color: '#000' } }} />} label="Electric (EV)" />
          </RadioGroup>

          <Typography sx={labelStyle}>Operator Full Name</Typography>
          {vehicleType === "Electric (EV)" ? (
            <Box
              sx={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "10px 10px 10px 16px",
                gap: "8px",
                width: "100%",
                maxWidth: "380px",
                background: "#FAFAFA",
                border: "1px solid #E3E7EF",
                borderRadius: "12px",
                marginBottom: "16px",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "'Proxima Nova'",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "16px",
                  lineHeight: "130%",
                  color: "rgba(15, 24, 40, 0.8)",
                }}
              >
                CarBEV
              </Typography>
            </Box>
          ) : (
            <Select
              value={operatorName}
              onChange={handleSelectChange}
              displayEmpty
              size="small"
              sx={{ width: "100%", maxWidth: "380px", marginBottom: "16px" }}
              inputProps={{ "aria-label": "select-option" }}
            >
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              {data
                .filter((option) => option?.operator_name?.toLowerCase() !== "carbev")
                .map((option) => (
                  <MenuItem value={option?.id} key={option.operator_name}>
                    {option.operator_name}
                  </MenuItem>
                ))}
            </Select>
          )}
        </Box>
      )}
    </Box>
  );
}
